import { render, staticRenderFns } from "./SettingDrawer.vue?vue&type=template&id=6dfd6b6b&scoped=true&"
import script from "./SettingDrawer.vue?vue&type=script&lang=js&"
export * from "./SettingDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SettingDrawer.vue?vue&type=style&index=0&id=6dfd6b6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd6b6b",
  null
  
)

export default component.exports